/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Video_ShareInputs */

const en_us2_share_video_share = /** @type {(inputs: Share_Video_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share video`)
};

const pt_br2_share_video_share = /** @type {(inputs: Share_Video_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar vídeo`)
};

const es_419_share_video_share = /** @type {(inputs: Share_Video_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir video`)
};

const pt_pt2_share_video_share = /** @type {(inputs: Share_Video_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partilhar vídeo`)
};

const fr_fr2_share_video_share = /** @type {(inputs: Share_Video_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager la vidéo`)
};

const de_de2_share_video_share = /** @type {(inputs: Share_Video_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video teilen`)
};

const it_it2_share_video_share = /** @type {(inputs: Share_Video_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi video`)
};

/**
* | output |
* | --- |
* | "Share video" |
*
* @param {Share_Video_ShareInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_video_share = /** @type {((inputs?: Share_Video_ShareInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Video_ShareInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_video_share(inputs)
	if (locale === "es-419") return es_419_share_video_share(inputs)
	if (locale === "pt-PT") return pt_pt2_share_video_share(inputs)
	if (locale === "fr-FR") return fr_fr2_share_video_share(inputs)
	if (locale === "de-DE") return de_de2_share_video_share(inputs)
	if (locale === "it-IT") return it_it2_share_video_share(inputs)
	return en_us2_share_video_share(inputs)
});
export { share_video_share as "share.video_share" }